import { authActionTypes } from '@actions/actionTypes/auth';
import { authInitialState } from './initialState/auth';
import { AnyAction } from 'redux';

export const authReducer = (state = authInitialState, action: AnyAction) => {
  switch (action.type) {
    case authActionTypes.LOGIN: {
      return { ...state, isLoggedIn: action.payload };
    }
    case authActionTypes.LOGIN_LOADING: {
      return { ...state, isLoginLoading: action.payload };
    }
    case authActionTypes.LOGIN_FAILURE: {
      return { ...state, isLoginFailure: action.payload };
    }
    case authActionTypes.LOGOUT: {
      return { ...state, isLoggedIn: action.payload };
    }
    case authActionTypes.SET_TOKEN: {
      return { ...state, token: action.payload };
    }
    default: {
      return state;
    }
  }
};
